import BaseModel from './BaseModel';
import Review from './Review';
import Researcher from './Researcher';
import { ReviewMemberRole } from '@/enums';

export default class ReviewMember extends BaseModel {
  constructor(data = {}) {
    super(ReviewMember, data);
    this.id = data.id;
    this.review = data.review ? new Review(data.review) : null;
    this.researcher = data.researcher
      ? new Researcher(data.researcher)
      : null;
    this.memberRole = data.memberRole || ReviewMemberRole.VIEWER;
    this.memberPermissions = data.memberPermissions || [];
  }

  creationData() {
    return {
      id: this.id,
      review: this.review?.id,
      researcher: this.researcher?.id,
      memberRole: this.memberRole,
    };
  }
}
